import React, { FC, useEffect, useState } from 'react'
import Card from 'react-bootstrap/Card'
import Button from 'react-bootstrap/Button'
import { Link } from 'react-router-dom'

import {
  preferedName,
  dataPortalTitle
} from '../../assets/i18n/i18n'

const COOKIE_NAME = 'cookieAcknowledged'

const CookieAcknowledgement: FC = () => {
  const [show, setShow] = useState(false)

  useEffect(() => {
    const cookieExists = document.cookie
      .split('; ')
      .some(cookie => cookie.startsWith(`${COOKIE_NAME}=`))

    setShow(!cookieExists)
  }, [])

  const handleAcknowledgement = () => {
    const expirationDate = new Date()

    expirationDate.setMonth(expirationDate.getMonth() + 6)

    document.cookie =
      `${COOKIE_NAME}=true; ` +
      `expires=${expirationDate.toUTCString()}; ` +
      'path=/; SameSite=Lax'

    setShow(false)
  }

  if (!show) {
    return null
  }

  return (
    <Card
      className='position-fixed bottom-0 start-0 end-0 mx-4 mb-0'
      style={{ zIndex: 1050 }}
    >
      <Card.Header className='text-center fw-bold'>
        Necessary Cookies Only
      </Card.Header>

      <Card.Body>
        <Card.Text>
          The {preferedName} {dataPortalTitle} uses Necessary Cookies Only. Cookie use is limited to only what is
          required for this service to function securely. We do not use
          cookies to access files on your device, monitor activity outside
          our services, or perform advertising tracking.
        </Card.Text>

        <Card.Text>
          For more information, please see the{' '}
          <Link to ='/cookies'>
            Cookie Policy
          </Link>.
        </Card.Text>
      </Card.Body>

      <Card.Footer className='text-end'>
        <Button
          variant='primary'
          size='sm'
          onClick={handleAcknowledgement}
        >
          OK
        </Button>
      </Card.Footer>
    </Card>
  )
}

export default CookieAcknowledgement